import React from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { LinkList } from '@eika/link-list';

import { useConfig } from '../../../defaultConfig';
import useTranslation from '../../../hooks/useTranslation';
import { settingsTrackIDs } from '../../../utils/gtm/trackIDs/settings';

const About: React.FC = () => {
    const translated = useTranslation();
    const { priceListLink, privacyLink, thirdPartyDependenciesLink, myActivationsLink } = useConfig();

    return (
        <>
            <h3 className="settings__title">{translated.settings.aboutApp}</h3>
            <LinkList className="settings__link-list">
                {priceListLink?.url && (
                    <LinkList.Item
                        href={priceListLink.url}
                        data-track-id={settingsTrackIDs.link}
                        data-track-linkname={translated.settings.price}
                    >
                        {translated.settings.price}
                    </LinkList.Item>
                )}
                {runningInRNWebView && thirdPartyDependenciesLink?.url && (
                    <LinkList.Item
                        href={thirdPartyDependenciesLink.url}
                        data-track-id={settingsTrackIDs.link}
                        data-track-linkname={translated.aboutApp.thirdPartyLicenses}
                    >
                        {translated.aboutApp.thirdPartyLicenses}
                    </LinkList.Item>
                )}
                {privacyLink?.url && (
                    <LinkList.Item
                        href={privacyLink.url}
                        data-track-id={settingsTrackIDs.link}
                        data-track-linkname={translated.aboutApp.privacy}
                    >
                        {translated.aboutApp.privacy}
                    </LinkList.Item>
                )}
                {!runningInRNWebView && myActivationsLink?.url && (
                    <LinkList.Item
                        href={myActivationsLink.url}
                        data-track-id={settingsTrackIDs.link}
                        data-track-linkname={translated.login.myActivations}
                    >
                        {translated.login.myActivations}
                    </LinkList.Item>
                )}
            </LinkList>
        </>
    );
};

export default About;
